<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="360px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="110px"
        :label-position="labelPosition"
      >
        <el-form-item label="开关:">
          <el-switch v-model="params.status"></el-switch>
        </el-form-item>

        <el-form-item label="排序:" prop="sort">
          <el-input v-model.number="params.sort" size="small"></el-input>
        </el-form-item>
        <el-form-item label="名称:" prop="name">
          <el-input v-model.trim="params.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="展示样式:" prop="showType">
          <el-select v-model="params.showType" size="small" clearable placeholder="请选择展示样式">
            <el-option v-for="item in showTypeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>         
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { validatorIndex } from "@/utils/validator";
export default {
  data() {
    return {
      dialogVisible: false,
      labelPosition: "left",
      title: "",
      flag: false,
      id: "",
      type: "",
      params: {
        name: "",
        sort: "",
        showType:'',
        status: false,
      },
      showTypeList:[{label:'横',value:1},{label:'竖',value:2}],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择开关状态", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addProduct();
          } else {
            this.editProduct();
          }
        } else {
          return false;
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        name: "",
        showType:'',
        sort: 0,
        status: false,
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑配置";
        this.params.name = data.name;
        this.params.showType = data.showType;        
        this.params.sort = data.sort;
        this.params.status = data.status;
        this.id = data.id;
      } else {
        this.title = "新增配置";
      }
    },
    // 新增
    addProduct() {
      API.addPosition(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑
    editProduct() {
      let form = Object.assign(this.params, { id: this.id });
      API.editPosition(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss" >
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
